<ss-modal
  [open]="!!verifiedAddress()"
  [enableCloseOutside]="false"
  [showClosingX]="false"
>
  @if (verifiedAddress()) {
    <form
      [formGroup]="selectAddressFormControl"
      (ngSubmit)="onSubmit()"
      class="p-8 text-ss-brown"
    >
      <h3>Verify your address</h3>
      <ss-radio-card-group formControlName="selectedAddress">
        <ss-radio-card value="SUGGESTED">
          <h4>Suggested Address</h4>
          <div>{{ verifiedAddress()! | address: 'street' }}</div>
          <div>
            {{ verifiedAddress()! | address: 'cityStateZip' }}
          </div>
        </ss-radio-card>
        <ss-radio-card value="ENTERED">
          <h4>Entered Address</h4>
          <div class="uppercase">
            {{ (address$ | async)! | address: 'street' }}
          </div>
          <div class="uppercase">
            {{ (address$ | async)! | address: 'cityStateZip' }}
          </div>
        </ss-radio-card>
      </ss-radio-card-group>
      <div class="flex justify-center mt-4">
        <ss-button buttonColor="principal" buttonStyle="filled" type="submit">
          Use This Address
        </ss-button>
      </div>
    </form>
  }
</ss-modal>
